<template>
  <div class="adminMainPage">
    <box :title="$t('downloadFiles')">
      <div class="pa-3 d-flex flex-column">
        <a
          href="https://www.mozilla.org/en-US/firefox/download/thanks/"
          class="my-1"
          >دریافت مرورگر Firefox</a
        >
        <a href="https://www.google.com/chrome/" class="my-1"
          >دریافت مرورگر Chrome</a
        >
      </div>
    </box>
  </div>
</template>

<script>
export default {
  mounted() {},
};
</script>

<style>
</style>